<template>
  <div class="appointmentType-CU">
    <v-icon class="close-btn" @click="$emit('closeDialog')">close</v-icon>
    <v-container>
      <h2 v-if="isUpdate">
        <h1 class="header-text">
          <span>Uređivanje tipa termina
            <div class="header-text-line"></div>
          </span>
        </h1>
      </h2>
      <h2 v-else>
        <h1 class="header-text">
          <span>Dodavanje tipa termina
            <div class="header-text-line"></div>
          </span>
        </h1>
      </h2>
      <v-form class="form">
        <v-flex xs12>
          <v-text-field v-model="appointmentType.Name" label="Naziv"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <span>Boja</span>
          <div class="color" :style="{backgroundColor:appointmentType.Color.hex}"></div>
        </v-flex>
        <v-flex xs12>
          <photoshop-picker v-model="appointmentType.Color"></photoshop-picker>
        </v-flex>
        <v-flex xs12 class="text-right">
          <v-btn class="main-btn" v-if="isUpdate" @click="updateAppointmentType">Sačuvaj</v-btn>
          <v-btn class="main-btn" v-else @click="postAppointmentType">Kreiraj</v-btn>
        </v-flex>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { Chrome } from "vue-color";
export default {
  props: ["appointmentTypeId", "isUpdate", "dialog"],
  components: {
    "photoshop-picker": Chrome
  },
  data() {
    return {
      appointmentType: {
        Color: {
          hex: "#FF0000"
        }
      }
    };
  },
  methods: {
    getAppointmentType() {
      this.$store.state.services.appointmentTypeService
        .get(this.appointmentTypeId)
        .then(response => {
          this.appointmentType = response.data;
          var color = this.appointmentType.Color;
          this.appointmentType.Color = { hex: color };
        });
    },
    postAppointmentType() {
      this.appointmentType.Color = this.appointmentType.Color.hex;
      this.$store.state.services.appointmentTypeService
        .add(this.appointmentType)
        .then(response => {
          this.$emit("addedOrChanged");
          this.resetAppointmentType();
        });
    },
    updateAppointmentType() {
      this.appointmentType.Color = this.appointmentType.Color.hex;
      this.$store.state.services.appointmentTypeService
        .update(this.appointmentType)
        .then(response => {
          this.$emit("addedOrChanged");
          this.resetAppointmentType();
        });
    },
    resetAppointmentType() {
      this.appointmentType = {
        Color: {
          hex: "#FF0000"
        }
      };
    }
  },
  watch: {
    appointmentTypeId() {
      this.getAppointmentType();
    },
    dialog() {
      if (this.dialog == false) {
        this.resetAppointmentType();
      } else if (this.isUpdate) {
        this.getAppointmentType();
      }
    }
  }
};
</script>

<style scoped>
.close-btn {
  float: right;
}
h2 {
  text-align: center;
}
.appointmentType-CU {
  padding: 10px 15px;
}
.color {
  height: 20px;
  margin-bottom: 15px;
  margin-top: 5px;
}

</style>
